!function (e) {
  e.languages.kotlin = e.languages.extend("clike", {
    keyword: {
      pattern: /(^|[^.])\b(?:abstract|actual|annotation|as|break|by|catch|class|companion|const|constructor|continue|crossinline|data|do|dynamic|else|enum|expect|external|final|finally|for|fun|get|if|import|in|infix|init|inline|inner|interface|internal|is|lateinit|noinline|null|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|to|try|typealias|val|var|vararg|when|where|while)\b/,
      lookbehind: !0
    },
    "function": [/\w+(?=\s*\()/, {
      pattern: /(\.)\w+(?=\s*\{)/,
      lookbehind: !0
    }],
    number: /\b(?:0[xX][\da-fA-F]+(?:_[\da-fA-F]+)*|0[bB][01]+(?:_[01]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?[fFL]?)\b/,
    operator: /\+[+=]?|-[-=>]?|==?=?|!(?:!|==?)?|[\/*%<>]=?|[?:]:?|\.\.|&&|\|\||\b(?:and|inv|or|shl|shr|ushr|xor)\b/
  }), delete e.languages.kotlin["class-name"], e.languages.insertBefore("kotlin", "string", {
    "raw-string": {
      pattern: /("""|''')[\s\S]*?\1/,
      alias: "string"
    }
  }), e.languages.insertBefore("kotlin", "keyword", {
    annotation: {
      pattern: /\B@(?:\w+:)?(?:[A-Z]\w*|\[[^\]]+\])/,
      alias: "builtin"
    }
  }), e.languages.insertBefore("kotlin", "function", {
    label: {
      pattern: /\w+@|@\w+/,
      alias: "symbol"
    }
  });
  var n = [{
    pattern: /\$\{[^}]+\}/,
    inside: {
      delimiter: {
        pattern: /^\$\{|\}$/,
        alias: "variable"
      },
      rest: e.languages.kotlin
    }
  }, {
    pattern: /\$\w+/,
    alias: "variable"
  }];
  e.languages.kotlin.string.inside = e.languages.kotlin["raw-string"].inside = {
    interpolation: n
  };
}(Prism);